import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Account, checkout, admin, setup/token and members-only routes: keep out of search indexes.
const PRIVATE = [/^\/login/, /^\/signup/, /^\/forgot-password/, /^\/reset-password/, /^\/dashboard/, /^\/orders?(\/|$)/,
  /^\/cart/, /^\/account\//, /^\/favorites/, /^\/subscribe/, /^\/subscription\//, /^\/farm-dashboard/, /^\/farm\//, /^\/farmer\/onboarding/,
  /^\/farm-setup/, /^\/admin/, /^\/marketplace(?!\/(listings|markets)\/[^/]+\/?$)/, /^\/explore/, /^\/welcome/, /^\/auth\//, /^\/directory\//];

export const isPrivatePath = (path) => PRIVATE.some((re) => re.test(path));

export default function RobotsMeta() {
  const { pathname } = useLocation();
  useEffect(() => {
    let el = document.querySelector('meta[name="robots"]');
    if (document.querySelector("[data-not-found]")) return; // NotFound manages its own noindex
    if (!isPrivatePath(pathname)) return el?.remove();
    if (!el) { el = document.createElement("meta"); el.name = "robots"; document.head.appendChild(el); }
    el.content = "noindex, nofollow";
  }, [pathname]);
  return null;
}
